import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  getProductsByPromos,
  getProductsByCategoryIds,
  getProductsByFulfillmentPlants,
} from 'selectors/products';
import Loader from 'components/Loader';
import Header from 'pages/browse-catalog/Header';
import Filters from 'pages/browse-catalog/Filters';
import Products from 'pages/browse-catalog/Products';
import { Container, Wrapper } from 'styles/pages/browse-catalog';

const BrowseCatalog = () => {
  const { state: locationState } = useLocation();
  const loaderVisibility = useSelector((state) => state?.loader?.visibility);
  const allProducts = useSelector((state) => state?.products?.data);
  const [products, setProducts] = useState(undefined);
  const [promos, setPromos] = useState([]);
  const [fulfillmentPlants, setFulfillmentPlants] = useState([]);
  const [categoriesFilter, setCategoriesFilter] = useState([]);
  const [stylesFilter, setStylesFilter] = useState([]);

  const [brands, setBrands] = useState([]);
  const [colorsFilter, setColorsFilter] = useState([]);

  const resetFilters = () => {
    setPromos([]);
    setCategoriesFilter([]);
    setStylesFilter([]);
    setBrands([]);
    setColorsFilter([]);
    setFulfillmentPlants([]);
    setProducts(allProducts);
  };

  useEffect(() => {
    let products = [];
    products = getProductsByPromos(allProducts, promos);
    products = getProductsByFulfillmentPlants(products, fulfillmentPlants);
    products = getProductsByCategoryIds(products, categoriesFilter);
    products = getProductsByPromos(products, stylesFilter);
    setProducts(products);
  }, [
    allProducts,
    promos,
    fulfillmentPlants,
    categoriesFilter,
    stylesFilter,
    setProducts,
    setPromos,
  ]);

  useEffect(() => {
    setPromos(
      locationState && locationState?.Promos ? [locationState.Promos] : []
    );

    setCategoriesFilter(
      locationState && locationState?.Categories
        ? [locationState.Categories]
        : []
    );

    setStylesFilter(
      locationState && locationState?.Styles ? [locationState.Styles] : []
    );
  }, [locationState]);

  return (
    <Container>
      <Header />
      <Wrapper>
        <Filters
          resetFilters={resetFilters}
          fulfillmentPlants={fulfillmentPlants}
          updateFulfillmentPlants={(fulfillmentPlant) => {
            const isExist = !!_.filter(
              fulfillmentPlants,
              (o) => o === fulfillmentPlant
            )?.length;

            if (isExist) {
              setFulfillmentPlants(
                _.filter(fulfillmentPlants, (o) => o !== fulfillmentPlant)
              );
            } else {
              setFulfillmentPlants([...fulfillmentPlants, fulfillmentPlant]);
            }
          }}
          promos={promos}
          updatePromos={(promo) => {
            const isExist = !!_.filter(promos, (o) => o.Id === promo.Id)
              ?.length;

            if (isExist) {
              setPromos(_.filter(promos, (o) => o.Id !== promo.Id));
            } else {
              setPromos([...promos, promo]);
            }
          }}
          categories={categoriesFilter}
          updateCategories={(categoryId) => {
            const isExist = !!_.filter(
              categoriesFilter,
              (o) => o === categoryId
            )?.length;
            if (isExist) {
              setCategoriesFilter(_.without(categoriesFilter, categoryId));
            } else {
              setCategoriesFilter([...categoriesFilter, categoryId]);
            }
          }}
          stylesFilter={stylesFilter}
          updateStylesFilter={(style) => {
            const isExist = !!_.filter(stylesFilter, (o) => o.Id === style.Id)
              ?.length;
            if (isExist) {
              setStylesFilter(_.filter(stylesFilter, (o) => o.Id !== style.Id));
            } else {
              setStylesFilter([...stylesFilter, style]);
            }
          }}
          brands={brands}
          updateBrandsFilter={(brandName) => {
            const isExist = !!_.filter(brands, (o) => o === brandName)?.length;
            if (isExist) {
              setBrands(_.without(brands, brandName));
            } else {
              setBrands([...brands, brandName]);
            }
          }}
          colorsFilter={colorsFilter}
          updateColorsFilter={(colorId) => {
            const isExist = !!_.filter(colorsFilter, (o) => o === colorId)
              ?.length;
            if (isExist) {
              setColorsFilter(_.without(colorsFilter, colorId));
            } else {
              setColorsFilter([...colorsFilter, colorId]);
            }
          }}
        />
        <Products resetFilters={resetFilters} products={products} />
      </Wrapper>
      {loaderVisibility && <Loader open={loaderVisibility} />}
    </Container>
  );
};

export default BrowseCatalog;
